import dayjs from 'dayjs';
import { usePDF } from 'react-to-pdf';
import { Pdf } from './Pdf';
import { Select } from '@shape-ds/components';
import { useAssetData } from 'pages/Asset/hooks/useAssetData';
import { BaseAsset } from 'queries/assets/contract';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

interface Props {
  assetId?: string;
}

export const PDFPreview = ({ assetId }: Props) => {
  const { targetRef } = usePDF();

  if (!assetId) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p>Please select a vessel to preview the PDF.</p>
      </div>
    );
  }

  return (
    <div ref={targetRef} className="pdf-preview">
      <Pdf
        asset={{
          id: assetId || '',
          name: '',
        }}
        date={dayjs()}
      />
    </div>
  );
};

const buildOptions = (data: BaseAsset[]) => {
  return data.map((item) => ({ label: item.name, value: item.id, external_id: item.external_id }));
};

export const PDFSelector = () => {
  const { assetParam } = useParams();
  const navigate = useNavigate();

  const { asset } = useAssetData();
  const equipmentOptions = buildOptions(asset.children || []);

  const findOption = (arg?: string) => {
    if (!arg) return undefined;

    return equipmentOptions.find(
      (option) => option.value === assetParam || option.label === assetParam,
    );
  };

  const vessel = findOption(assetParam);

  const [selectedAsset, setSelectedAsset] = useState<string>(vessel?.value || '');

  const handleChange = (event: any) => {
    setSelectedAsset(event.target.value);
    const option = findOption(event.target.value);
    if (option) navigate(`/pdf/${option.label}`, { replace: true });
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '16px',
        }}
      >
        <Select
          data={equipmentOptions}
          onChange={handleChange}
          label="Select vessel"
          placeholder="select an option"
          value={selectedAsset}
        />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PDFPreview assetId={selectedAsset} />
      </div>
    </div>
  );
};
